<template>
  <div class="login-content">
    <div v-click-outside="onClickOutside" class="modal-login">
      <div class="item--title">
        <span class="item--title">
          Registering to this website, accept our Privacy policy.
        </span>
        <span class="item--close" @click="closeModal"
          ><font-awesome-icon
            class="item--close-icon"
            id="user--btn-icon"
            icon="times"
        /></span>
      </div>
      <div class="form-login" @keyup.enter="signup">
        <div class="area-input">
          <input
            class="item--input"
            v-model="form.username"
            placeholder="Username"
            type="text"
          />
          <font-awesome-icon class="input--icon" icon="user" />
        </div>
        <div class="area-input">
          <input
            class="item--input"
            v-model="$v.form.email.$model"
            @input="delayTouch($v.form.email)"
            placeholder="Email"
            type="text"
            :class="{ error: $v.form.email.$error }"
          />
          <font-awesome-icon class="input--icon" icon="envelope" />
          <p
            class="error-msg"
            v-if="$v.form.email.$error && !$v.form.email.email"
          >
            Enter a valid email
          </p>
        </div>
        <div class="area-input">
          <input
            class="item--input"
            v-model="$v.form.password.$model"
            @input="delayTouch($v.form.password)"
            placeholder="Password"
            type="password"
            :class="{ error: $v.form.password.$error }"
          />
          <font-awesome-icon class="input--icon" icon="lock" />
          <p
            class="error-msg"
            v-if="$v.form.password.$error && !$v.form.password.minLength"
          >
            Password must have at least
            {{ $v.form.password.$params.minLength.min }} characters.
          </p>
        </div>
        <div class="area-input">
          <input
            class="item--input"
            v-model="$v.form.repeat.$model"
            @input="delayTouch($v.form.password)"
            placeholder="Repat password"
            type="password"
          />
          <font-awesome-icon class="input--icon" icon="lock" />
          <p
            class="error-msg"
            v-if="$v.form.repeat.$error && !$v.form.repeat.minLength"
          >
            Password does not match.
          </p>
        </div>
      </div>
      <div class="area-btn-login">
        <button class="item--btn btn-login" @click.prevent="signup">
          Sign Up
        </button>
        <div class="item--register">
          Already have an account?
          <strong class="item--login" @click="loginModal()"> Log in</strong>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { mapState } from "vuex";
import vClickOutside from "v-click-outside";
import { required, email, minLength, sameAs } from "vuelidate/lib/validators";
const touchMap = new WeakMap();

export default {
  name: "IthMenuAsside",
  data: () => ({
    login: false,
    directives: {
      clickOutside: vClickOutside.directive
    },
    form: { username: "", email: "", password: "", repeat: "" },
    alert: { color: "", message: "" }
  }),
  computed: {
    menuAsside() {
      return this.$store.state.menuAsside;
    },

    usernameErrors() {
      const errors = [];
      if (!this.$v.form.username.$dirty) return errors;
      !this.$v.form.username.minLength && errors.push("Campo requerido.");
      !this.$v.form.username.email && errors.push("Campo requerido.");
      !this.$v.form.username.required && errors.push("Campo requerido.");
      return errors;
    }
  },
  methods: {
    onClickOutside(event) {
      if (event.target.className == "login-content") {
        this.$store.commit("DISABLED_MENU");
      } //this.menuAsside != true &&
    },
    closeModal() {
      this.$store.commit("toggleRegisterModal");
      this.$store.commit("DISABLED_MENU");
    },
    async signup() {
      const user = new this.$Parse.User();
      user.set("username", this.form.username);
      user.set("email", this.form.email);
      user.set("password", this.form.password);
      user.set("name", this.form.username);
      user.set("country", "USA");
      await user
        .signUp()
        .then(response => {
          this.alert.color = "#94C659";
          this.alert.message = "Resgister Successful";
          this.$store.commit("editAlert", this.alert);
          this.$store.commit("DISABLED_MENU");
          this.$store.commit("dataUser", response.attributes);
        })
        .catch(response => {
          this.alert.color = "#EF3D58";
          this.alert.message = response.message;
          this.$store.commit("editAlert", this.alert);
        });
    },
    loginModal() {
      this.$store.commit("DISABLED_MENU");
      this.$store.commit("toggleLoginModal");
    },
    delayTouch($v) {
      $v.$reset();
      if (touchMap.has($v)) {
        clearTimeout(touchMap.get($v));
      }
      touchMap.set($v, setTimeout($v.$touch, 1000));
    }
  },
  validations: {
    form: {
      email: {
        required,
        email
      },
      password: {
        required,
        minLength: minLength(3)
      },
      repeat: {
        sameAsPassword: sameAs("password")
      }
    }
  }
};
</script>

<style scoped>
.login-content {
  background-color: rgba(44, 56, 72, 0.8);
  height: 100vh;
  width: 100vw;
  padding-top: 15vh;
}
.modal-login {
  background-color: #284060;
  height: 450px;
  width: 30vw;
  border-radius: 40px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: 70px 240px 100px;
  row-gap: 2%;
  justify-content: space-between;
  padding: 10px 15vh;
  position: relative;
}

.item--close {
  justify-self: end;
  position: absolute;
  right: 3%;
  width: 20px;
  height: 20px;
  border: 1px solid #cdcdcd;
  border-radius: 20px;
  text-align: center;
  cursor: pointer;
  top: 10px;
}
.item--close-icon {
  font-size: 11px;
  padding-top: 4.2px;
  padding-bottom: 3px;
}
.item--title {
  text-align: center;
  padding-top: 30px;
}
.form-login,
.area-btn-login,
.area--rrss {
  display: flex;
  flex-direction: column;
}

.area--rrss {
  min-height: 250px;
}
.area-input {
  position: relative;
}

.item--input {
  width: 100%;
  height: 40px;
  margin: 7px 0 0 0;
  background-color: #375072;
  border-radius: 15px;
  border: none;
  padding-left: 40px;
  padding-bottom: 0px;
  box-sizing: border-box;
}
.item--input::placeholder {
  color: rgba(255, 255, 255, 0.8);
}
.input--icon {
  position: absolute;
  left: 18px;
  right: 0;
  top: 18px;
  bottom: 0;
}
.item--forgot-password {
  text-align: center;
  margin: 7px 0;
  font-weight: 800;
}

.item--btn {
  margin: 7px 0;
  border: none;
  border-radius: 20px;
  color: white;
  font-family: Montserrat;
  cursor: pointer;
}
.item--register {
  text-align: center;
}
.btn-login {
  background-color: #94c659;
  font-size: 20px;
  font-weight: 600;
  height: 40px;
  width: 100%;
  margin: 10px auto;
}
.item--login {
  cursor: pointer;
}

/*VALIDACIONES */
.error {
  border: 1px solid red;
}
.error-msg {
  color: red;
  font-size: 0.7em;
  margin-left: 5%;
}

@media (min-width: 1480px) {
  .modal-login {
    height: 50vh;
    width: 20vw;
    border-radius: 20px;
    margin: 0 auto;
    padding: 10px 4vh;
  }
}
@media (min-width: 1264px) and (max-width: 1400px) {
  .modal-login {
    /* height: 80vh; */
    width: 50vw;
    border-radius: 20px;
    margin: 0 auto;
    padding: 10px 4vh;
  }
}
@media (min-width: 1020px) and (max-width: 1264px) {
  .modal-login {
    /* height: 60vh; */
    width: 50vw;
    border-radius: 20px;
    margin: 0 auto;
    padding: 10px 4vh;
  }
}
@media (min-width: 960px) and (max-width: 1020px) {
  .modal-login {
    /* height: 60vh; */
    width: 50vw;
    border-radius: 20px;
    margin: 0 auto;
    padding: 10px 4vh;
  }
}
@media (min-width: 960px) and (max-width: 1264px) {
  .modal-login {
    /* height: 50vh; */
    width: 50vw;
    border-radius: 20px;
    margin: 0 auto;
    padding: 10px 4vh;
  }
}
@media (min-width: 600px) and (max-width: 960px) {
  .modal-login {
    height: 70vh;
    width: 65vw;
    border-radius: 20px;
    margin: 0 auto;
    padding: 10px 8vh;
  }
}
@media (max-width: 600px) {
  .modal-login {
    /* height: 75vh; */
    width: 80vw;
    border-radius: 20px;
    margin: 0 auto;
    padding: 10px 2vh;
  }

  .item--close {
    right: 3%;
    top: 6px;
  }
  .item--title {
    margin-top: 12px;
  }
}
</style>
